export const upsProblems = [
  {
    slug: 'shopify-alternatives',
    label: 'Switch away from Shopify',
    serviceName: 'Shopify Alternatives for UPS Customers',
    summary:
      'Explore lower-cost Shopify alternatives while keeping a familiar shopping experience.',
    relatedServices: [
      { href: '/bigcommerce', label: 'BigCommerce Development' },
      { href: '/ecommerce-consulting', label: 'Ecommerce Consulting' },
      { href: '/web-design', label: 'Ecommerce Web Design' },
    ],
  },
  {
    slug: 'website-looks-outdated',
    label: 'Website looks outdated',
    serviceName: 'Website Redesign for UPS Customers',
    summary:
      'Refresh an outdated store with clearer pages and easier shopping.',
    relatedServices: [
      { href: '/web-design', label: 'Ecommerce Web Design' },
      { href: '/ecommerce-website-redesign', label: 'Website Redesign' },
      { href: '/vip-support', label: 'Ongoing Website Support' },
    ],
  },
  {
    slug: 'low-conversion-rate',
    label: 'Low conversion rate',
    serviceName: 'Conversion Help for UPS Customers',
    summary:
      'Find and fix the problems that stop website visitors from buying.',
    relatedServices: [
      {
        href: '/conversion-rate-optimization',
        label: 'Conversion Rate Optimization',
      },
      { href: '/ecommerce-website-audit', label: 'Website Audit' },
      { href: '/web-design', label: 'Ecommerce Web Design' },
    ],
  },
  {
    slug: 'one-time-buyers-do-not-return',
    label: 'One-time buyers do not return',
    serviceName: 'Repeat Customer Marketing for UPS Customers',
    summary:
      'Use helpful follow-up emails and a clear plan to bring customers back.',
    relatedServices: [
      { href: '/email-marketing', label: 'Email Marketing' },
      {
        href: '/klaviyo-email-marketing-agency',
        label: 'Klaviyo Email Marketing',
      },
      {
        href: '/case-study/stair-warehouse',
        label: 'Stair Warehouse Email Example',
      },
    ],
  },
  {
    slug: 'low-social-media-engagement',
    label: 'Low social media engagement',
    serviceName: 'Social Media Help for UPS Customers',
    summary:
      'Build a useful social media plan that connects your products with shoppers.',
    relatedServices: [
      { href: '/social-media-marketing', label: 'Social Media Marketing' },
      { href: '/paid-search', label: 'Paid Search' },
      { href: '/ecommerce-consulting', label: 'Ecommerce Consulting' },
    ],
  },
  {
    slug: 'slow-website',
    label: 'Slow website',
    serviceName: 'Website Speed Help for UPS Customers',
    summary:
      'Find slow pages, improve loading, and test the changes on phones and computers.',
    relatedServices: [
      {
        href: '/website-speed-optimization',
        label: 'Website Speed Optimization',
      },
      { href: '/ecommerce-website-maintenance', label: 'Website Maintenance' },
      { href: '/ecommerce-website-audit', label: 'Website Audit' },
    ],
  },
  {
    slug: 'website-is-not-mobile-friendly',
    label: 'Website is not mobile friendly',
    serviceName: 'Mobile Website Help for UPS Customers',
    summary:
      'Make menus, product pages, and checkout easier to use on a phone.',
    relatedServices: [
      { href: '/web-design', label: 'Ecommerce Web Design' },
      {
        href: '/conversion-rate-optimization',
        label: 'Conversion Rate Optimization',
      },
      {
        href: '/website-speed-optimization',
        label: 'Website Speed Optimization',
      },
    ],
  },
  {
    slug: 'high-cart-abandonment',
    label: 'High cart abandonment',
    serviceName: 'Cart Abandonment Help for UPS Customers',
    summary:
      'Remove buying obstacles and follow up with shoppers who leave their carts.',
    relatedServices: [
      {
        href: '/conversion-rate-optimization',
        label: 'Conversion Rate Optimization',
      },
      {
        href: '/klaviyo-email-marketing-agency',
        label: 'Klaviyo Email Marketing',
      },
      {
        href: '/case-study/stair-warehouse',
        label: 'Stair Warehouse Cart Follow-Up',
      },
    ],
  },
  {
    slug: 'hard-to-hire-reliable-help',
    label: 'Hard to hire reliable help',
    serviceName: 'Reliable Ecommerce Help for UPS Customers',
    summary:
      'Get a clear work plan and an experienced team for store updates and marketing.',
    relatedServices: [
      { href: '/vip-support', label: 'VIP Support' },
      { href: '/ecommerce-website-maintenance', label: 'Website Maintenance' },
      { href: '/ecommerce-consulting', label: 'Ecommerce Consulting' },
    ],
  },
  {
    slug: 'not-showing-up-on-google',
    label: 'Not showing up on Google',
    serviceName: 'Google Search Help for UPS Customers',
    summary:
      'Find search visibility problems and improve the pages shoppers need to find.',
    relatedServices: [
      { href: '/seo', label: 'Ecommerce SEO' },
      { href: '/ecommerce-seo-audit', label: 'Ecommerce SEO Audit' },
      {
        href: '/google-merchant-center-services',
        label: 'Google Merchant Center',
      },
    ],
  },
  {
    slug: 'low-email-open-or-click-rates',
    label: 'Low email open or click rates',
    serviceName: 'Email Performance Help for UPS Customers',
    summary:
      'Improve email delivery, messages, and links so shoppers have a reason to act.',
    relatedServices: [
      { href: '/email-marketing', label: 'Email Marketing' },
      {
        href: '/klaviyo-email-marketing-agency',
        label: 'Klaviyo Email Marketing',
      },
      {
        href: '/case-study/stair-warehouse',
        label: 'Stair Warehouse Email Example',
      },
    ],
  },
  {
    slug: 'inconsistent-sales-month-to-month',
    label: 'Inconsistent sales month to month',
    serviceName: 'Ecommerce Growth Planning for UPS Customers',
    summary:
      'Understand changing sales and build a coordinated store and marketing plan.',
    relatedServices: [
      { href: '/ecommerce-consulting', label: 'Ecommerce Consulting' },
      { href: '/email-marketing', label: 'Email Marketing' },
      {
        href: '/case-study/milian-truck-center',
        label: 'Milian Truck Center Marketing Example',
      },
    ],
  },
  {
    slug: 'checkout-process-is-confusing',
    label: 'Checkout process is confusing',
    serviceName: 'Checkout Help for UPS Customers',
    summary:
      'Make checkout steps, forms, delivery choices, and payment instructions clearer.',
    relatedServices: [
      {
        href: '/conversion-rate-optimization',
        label: 'Conversion Rate Optimization',
      },
      { href: '/shopify-theme-customization', label: 'Shopify Development' },
      { href: '/bigcommerce', label: 'BigCommerce Development' },
    ],
  },
  {
    slug: 'ads-are-not-generating-sales',
    label: 'Ads are not generating sales',
    serviceName: 'Advertising Help for UPS Customers',
    summary:
      'Review ad spending, customer searches, landing pages, and sales tracking.',
    relatedServices: [
      { href: '/paid-search', label: 'Paid Search' },
      {
        href: '/google-shopping-management',
        label: 'Google Shopping Management',
      },
      {
        href: '/case-study/lummi-island-wild',
        label: 'Lummi Island Wild Ads Example',
      },
    ],
  },
  {
    slug: 'lack-of-customer-insights-or-analytics',
    label: 'Lack of customer insights or analytics',
    serviceName: 'Customer Analytics Help for UPS Customers',
    summary:
      'Set up useful tracking and explain where shoppers come from and where they leave.',
    relatedServices: [
      { href: '/ecommerce-website-audit', label: 'Website Audit' },
      { href: '/ecommerce-consulting', label: 'Ecommerce Consulting' },
      {
        href: '/conversion-rate-optimization',
        label: 'Conversion Rate Optimization',
      },
    ],
  },
].map((problem) => ({
  ...problem,
  path: `/ups/${problem.slug}`,
  metaDescription: `${problem.summary} Ventura helps with your UPS Account Manager, the UPS Exclusive Discount, and eligible Digital Connections funding.`,
}))
